import { MessageTemplate, MessageTypeEnum } from 'api/MessagesApi';
import confetti from 'canvas-confetti';
import { MessageProvider } from 'components/Message/CreateMessageComponent/MessageContext';
import StepEvent from 'components/Message/CreateMessageComponent/StepEvent/StepEvent';
import StepMessage from 'components/Message/CreateMessageComponent/StepMessage/StepMessage';
import StepRecipient from 'components/Message/CreateMessageComponent/StepRecipient/StepRecipient';
import StepSuccess from 'components/Message/CreateMessageComponent/StepSuccess/StepSuccess';
import StepTitle from 'components/Message/CreateMessageComponent/StepTitle/StepTitle';
import SaveExitMessageModalComponent, {
  SAVE_EXIT_MESSAGE_MODAL_NAME
} from 'components/Message/SaveExitMessageModalComponent/SaveExitMessageModalComponent';
import { useMessageService } from 'components/Message/useMessageService';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { openModal } from 'store/modalSlice';
import { useAppDispatch } from 'store/store';
import './CreateMessageComponent.css';

export const enum CreateMessageStepsEnum {
  Recipient,
  Event,
  Message,
  Title,
  Success
}

type AllProps = {
  initMessageType?: MessageTypeEnum;
  initMessageTemplate?: MessageTemplate;
  initStep?: CreateMessageStepsEnum;
};

function CreateMessageComponent({ initMessageType, initMessageTemplate, initStep }: AllProps) {
  const dispatch = useAppDispatch();
  const [currentStep, setCurrentStep] = useState(initStep || CreateMessageStepsEnum.Recipient);
  const { message } = useMessageService();

  useEffect(() => {
    if (typeof initStep !== 'undefined') {
      setCurrentStep(initStep);
    }
  }, [initStep]);

  const navigate = useNavigate();

  const messageType = message?.type || initMessageType || MessageTypeEnum.Text;

  useEffect(() => {
    if (currentStep === CreateMessageStepsEnum.Success) {
      confetti({
        particleCount: 150,
        spread: 60,
        zIndex: 99999
      });
    }
  }, [currentStep]);

  const handleNext = (shouldExit = false) => {
    if (shouldExit) {
      dispatch(openModal({ name: SAVE_EXIT_MESSAGE_MODAL_NAME }));
    } else {
      setCurrentStep(currentStep + 1);
    }
  };
  const handleBack = () => setCurrentStep(currentStep - 1);

  return (
    <>
      <div className="create-message-component">
        <MessageProvider>
          {currentStep === CreateMessageStepsEnum.Recipient && (
            <StepRecipient
              messageType={messageType}
              onNext={(message, shouldExit) => {
                if (shouldExit) {
                  handleNext(shouldExit);
                  return;
                }

                setCurrentStep(CreateMessageStepsEnum.Event);
                navigate(`/message/${message.id}`, {
                  state: { messageTemplate: initMessageTemplate, step: CreateMessageStepsEnum.Event }
                });
              }}
            />
          )}

          {currentStep === CreateMessageStepsEnum.Event && (
            <StepEvent initEventType={initMessageTemplate?.eventType} onNext={handleNext} onBack={handleBack} />
          )}

          {currentStep === CreateMessageStepsEnum.Message && (
            <StepMessage
              initContent={initMessageTemplate?.content}
              initTitle={initMessageTemplate?.title}
              onNext={handleNext}
              onBack={handleBack}
              goToDeliveryInfo={() => setCurrentStep(CreateMessageStepsEnum.Recipient)}
            />
          )}

          {currentStep === CreateMessageStepsEnum.Title && (
            <StepTitle initTitle={initMessageTemplate?.title} onNext={handleNext} onBack={handleBack} />
          )}

          {currentStep === CreateMessageStepsEnum.Success && <StepSuccess />}
        </MessageProvider>
      </div>

      <SaveExitMessageModalComponent />
    </>
  );
}

export default CreateMessageComponent;
